import { FC } from 'react';
// component
import EditOrgStaffComponent from 'components/main/Users/Staff';

const EditOrgStaff: FC = () => <EditOrgStaffComponent />;

export default EditOrgStaff;
